module.exports = __webpack_public_path__ + "assets/1707a7531cfc845a2824e2ecf025ace2.mp3";